// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__2BF-e","Header":"Modal_Header__2m7st","alertModalClass":"Modal_alertModalClass__14eHz"};